let claimNotesCols = [
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date'
    },
    {
        key: 'username',
        display: 'User'
    },
    {
        key: 'title',
        display: 'Title'
    }
]

export { claimNotesCols }